export default `float e, s=3.;
  p=.7-abs(p);
  p.x<p.y?p=p.yxz:p;
  for(int i=0;i++<8;)
    p=abs(p)-.9,
    e=dot(p,p),
    s*=e=2./min(e,2.)+6./min(e,.9),
    p=abs(p)*e-vec3(2.0,7.0,3.0);
  return e=length(p.yz)/s;
}`